export default __webpack_public_path__ + "static/media/cichlidogyrus.9b453f87.jpg";